import { useEffect, useRef } from "react";

export const Snow = ({ className = "", density = 140 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let flakes = [];

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
      ctx.setTransform(window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const w = () => canvas.offsetWidth;
    const h = () => canvas.offsetHeight;
    const spawn = (fresh) => ({
      x: Math.random() * w(),
      y: fresh ? -6 : Math.random() * h(),
      r: 1 + Math.random() * 2.4,
      s: 0.4 + Math.random() * 1.1,
      drift: 0.3 + Math.random() * 0.9,
      phase: Math.random() * Math.PI * 2,
    });
    flakes = Array.from({ length: density }, () => spawn(false));

    const loop = (t) => {
      ctx.clearRect(0, 0, w(), h());
      flakes.forEach((f) => {
        f.y += f.s;
        f.x += Math.sin(t / 1600 + f.phase) * f.drift * 0.4;
        if (f.y > h() + 5) Object.assign(f, spawn(true));
        if (f.x > w() + 5) f.x = -5;
        if (f.x < -5) f.x = w() + 5;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${0.3 + f.r * 0.16})`;
        ctx.fill();
      });
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [density]);

  return <canvas ref={ref} className={className} data-testid="snow-canvas" aria-hidden="true" />;
};
